const WorkShift = () => import("./views/WorkShift.vue");
const WorkShiftForm = () => import("./views/WorkShiftForm.vue");
const WorkShiftDetailsView = () => import("./views/WorkShiftDetailsView.vue");
const AssignEmployees = () => import("./views/AssignEmployees.vue");
const Roaster = () => import("./views/Roaster.vue");
const RoasterForm = () => import("./views/RoasterForm.vue");
const SynchronizeEmployees = () => import("./views/SynchronizeEmployees.vue");
const WorkshiftSettings = () => import("./views/WorkshiftSettings.vue");
const ShiftTypeSettings = () => import("./views/ShiftTypeSettings.vue");
const ClockSettings = () => import("./views/ClockSettings.vue");
const ClockOptionsSettings = () => import("./views/ClockOptionsSettings.vue");
const Calendar = () => import("./views/Calendar.vue");

export default [
  {
    path: "all",
    component: WorkShift,
  },
  {
    path: "create",
    component: WorkShiftForm,
  },
  {
    path: "edit/:id",
    component: WorkShiftForm,
  },
  {
    path: "details/:id",
    component: WorkShiftDetailsView,
  },
  {
    path: "assign-employee/:id",
    component: AssignEmployees,
  },
  {
    path: "roaster",
    component: Roaster,
  },
  {
    path: "calendar",
    component: Calendar,
  },
  {
    path: "roaster/create",
    component: RoasterForm,
  },
  {
    path: "synchronize",
    component: SynchronizeEmployees,
  },
  {
    path: "settings",
    component: WorkshiftSettings,
  },
  {
    path: "settings/shift-type",
    component: ShiftTypeSettings,
  },
  {
    path: "settings/clock",
    component: ClockSettings,
  },
  {
    path: "settings/clock-options",
    component: ClockOptionsSettings,
  },
];
